import axiosInterceptorInstance from "@/lib/axios"

type TdeviceID = string | null

// checkFingerprint is a cosmetic availability probe, not a critical call, so
// it gets a SHORTER budget than the global axios default (5s) rather than a
// longer one — a slow/unavailable auth service should not make the caller
// wait as long as a real request would.
export const FINGERPRINT_PROBE_TIMEOUT_MS = 3_000

class BiometricService {
  registerUser(deviceID: TdeviceID) {
    return axiosInterceptorInstance.get(
      `/auth/fingerprint/register?device_id=${deviceID}`,
    )
  }

  verificationRegisterResponse(credentialData: any) {
    return axiosInterceptorInstance.post(
      "/auth/fingerprint/verify",
      credentialData,
    )
  }

  loginUser(deviceID: TdeviceID) {
    return axiosInterceptorInstance.get(
      `/auth/fingerprint/login?device_id=${deviceID}`,
    )
  }

  verificationLoginResponse(assertationData: any) {
    return axiosInterceptorInstance.post(
      "/auth/fingerprint/login/verify",
      assertationData,
    )
  }

  disableFingerprint(deviceID: TdeviceID) {
    return axiosInterceptorInstance.delete(
      `/auth/fingerprint?device_id=${deviceID}`,
    )
  }

  checkFingerprint(deviceID: TdeviceID) {
    return axiosInterceptorInstance.get(
      `/auth/fingerprint?device_id=${deviceID}`,
      { timeout: FINGERPRINT_PROBE_TIMEOUT_MS },
    )
  }
}

const biometricService = new BiometricService()

export default biometricService
